import styled from '@emotion/styled';

import {
  black54,
  black60,
  black87,
  dustyOrangeTwo,
  greyBackground,
  lightGreyVarient,
} from '~/styles';

export const ModalContentWrapper = styled.div`
  border-radius: 3px;
  text-align: center;
  margin: auto;

  background-color: #fff;
`;

export const MembershipText = styled.p`
  text-align: center;
  margin-bottom: 15px;
  font-size: 20px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.75;
  letter-spacing: 0.5px;
  color: ${black87};
  margin: 20px 0px;
`;

export const StyledSetEmailForm = styled.div`
  form {
    margin: auto;
  }
  form button {
    min-width: 40px !important;
    border-radius: 4px !important;
    height: 38px;
    margin: 10px 0px;
  }
`;

export const P = styled.p`
  text-align: center;
  margin-bottom: 0px;
  margin-top: 10px;
  font-size: 13px;
  color: ${black54};
  padding-top: 10px;
`;

export const ModalFooter = styled.div`
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: end;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid ${lightGreyVarient};
  border-bottom-right-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
  background-color: ${greyBackground};
`;

export const BottomLeftText = styled.div`
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.71;
  letter-spacing: 0.1px;
  color: ${black60};
  text-align: left;
  margin-right: auto;
`;

export const BottomRightLinkText = styled.a`
  font-weight: 600;
  text-transform: uppercase;
  color: ${dustyOrangeTwo};
  font-size: 14px;
`;
